var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('BaseCell',{attrs:{"align":"right"}},[_c('ChipStatus',{attrs:{"status":_vm.status,"label":_vm.label}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }